import WebsiteLayout from "../../layout/website/WebsiteLayout";
import AboutUs from "../../view/website/aboutUs/AboutUs";
import ForgetPassword from "../../view/website/auth/ForgetPassword";
import ResetPassword from "../../view/website/auth/ResetPassword";
import SignIn from "../../view/website/auth/SignIn";
import SignUp from "../../view/website/auth/SignUp";
import Blog from "../../view/website/blog/Blog";
import Booking from "../../view/website/booking/Booking";
import BookingPDFSample from "../../view/website/booking/BookingPDFSample";
import HotelBookingFailed from "../../view/website/booking/HotelBookingFailed";
import HotelBookingSuccess from "../../view/website/booking/HotelBookingSuccess";
import Dashboard from "../../view/website/dashboard/Dashboard";
import DeliveryPolicy from "../../view/website/deliveryPolicy/DeliveryPolicy";
import Error from "../../view/website/error/Error";
import Home from "../../view/website/home/Home";
import Hotel from "../../view/website/hotel/Hotel";
import OfferPage from "../../view/website/offer/OfferPage";
import OffersPage from "../../view/website/offers/OffersPage";
import Paylater from "../../view/website/paylater/Paylater";
import PreLoader from "../../view/website/preloader/PreLoader";
import PrivacyPolicy from "../../view/website/PrivacyPolicy/PrivacyPolicy";
import RefundPolicy from "../../view/website/RefundPolicy/RefundPolicy";
import SearchList from "../../view/website/search/SearchList";
import TermsAndConditions from "../../view/website/Termsandconditon/TermsAndCondition";
import TourBooking from "../../view/website/tourBooking/TourBooking";
import TourBookingFailed from "../../view/website/tourBooking/TourBookingFailed";
import TourBookingSuccess from "../../view/website/tourBooking/TourBookingSuccess";
import SingleTour from "../../view/website/tours/SingleTour";
import Tours from "../../view/website/tours/Tours";
import ProtectedRoute from "./protectedRoute";
import PublicRoute from "./PublicRoute";

const websiteRouter = {
  path: "/",
  element: <WebsiteLayout />,
  children: [
    {
      path: "/",
      element: <Home />,
    },
    {
      path: "/offer/:id/:offerTitle",
      element: <OfferPage />,
    },
    {
      path: "/blog/:id/:blogTitle",
      element: <Blog />,
    },
    {
      path: "/hotel/details/:id/:hotelTitle",
      element: <Hotel />,
    },
    {
      path: "/authentication/signin",
      element: <SignIn />,
    },
    {
      path: "/authentication/signup",
      element: (
        <PublicRoute>
          <SignUp />
        </PublicRoute>
      ),
    },
    {
      path: "/paylater/:invoiceId",
      element: (
        <PublicRoute>
          <Paylater />
        </PublicRoute>
      ),
    },
    {
      path: "/authentication/forget-password",
      element: (
        <PublicRoute>
          <ForgetPassword />
        </PublicRoute>
      ),
    },
    {
      path: "/authentication/new-password?",
      element: (
        <PublicRoute>
          <ResetPassword />
        </PublicRoute>
      ),
    },
    {
      path: "/product/search?",
      element: <SearchList />,
    },

    {
      path: "/hotel/booking",
      element: <Booking />,
    },

    {
      path: "/hotel/payment/success/:transactionId",
      element: <HotelBookingSuccess />,
    },
    {
      path: "/hotel/payment/failed/:transactionId",
      element: <HotelBookingFailed />,
    },
    {
      path: "/customer/dashboard",
      element: (
        <ProtectedRoute>
          <Dashboard />
        </ProtectedRoute>
      ),
    },
    {
      path: "/about-us",
      element: <AboutUs />,
    },
    {
      path: "/refund-policy",
      element: <RefundPolicy />,
    },
    {
      path: "/privacy-policy",
      element: <PrivacyPolicy />,
    },
    {
      path: "/delivery-policy",
      element: <DeliveryPolicy />,
    },
    {
      path: "/terms-and-conditions",
      element: <TermsAndConditions />,
    },
    {
      path: "/offers",
      element: <OffersPage />,
    },
    {
      path: "/tours",
      element: <Tours />,
    },
    {
      path: "/tour/details/:id/:tourName",
      element: <SingleTour />,
    },
    {
      path: "/booking/tour",
      element: <TourBooking />,
    },
    {
      path: "/tour/booking/success/:transactionId",
      element: <TourBookingSuccess />,
    },
    {
      path: "/tour/booking/failed/:transactionId",
      element: <TourBookingFailed />,
    },
    {
      path: "/pdf",
      element: <BookingPDFSample />,
    },
    {
      path: "*",
      element: <Error />,
    },
    {
      path: "/p",
      element: <PreLoader />,
    },
  ],
};

export default websiteRouter;
